import { configureStore } from '@reduxjs/toolkit'
import packagesSlice from './slice/packagesSlice'

export const store = configureStore({
  reducer: {
    package: packagesSlice,
  },
})
export type RootState = ReturnType<typeof store.getState>
